
import { signUpUser } from "../util/firestoreModel";

import {SignUpView} from "../views/signUpView";

function SignUp() {
  async function handleSignUp(email, password, firstName, lastName) {
    try {
      await signUpUser(email, password, firstName, lastName);


      window.location.hash = "#/mapOverview";
    } catch (error) {
      console.error("Signup error:", error);
      alert(error.message);
    }
  }

  return <SignUpView onSignUp={handleSignUp} />;
}

export  {SignUp};
